// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"7b49b65b","255":"87b0c955","348":"ad5620b3","637":"1dba6812"}[chunkId] + ".chunk.css";
};